import * as _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { constants } from '../../shared/constants';
import CustomWidget from '../Custom/CustomWidget';
import ChartReliability from './Charts/ChartReliability';
import ChartReliabilityScores from './Charts/ChartReliabilityScore';
import ReliabilityScoresYearly from './Charts/ChartReliabilityScoreYearly';

const startYear = 2019;
const currentYear = new Date().getFullYear() + 1;
const Years = _.range(startYear, currentYear);

const MonthYear = ({ onDDLChange, defaultValue }) => (
  <Row>
    <Col lg={12} style={{ marginLeft: '5px' }}>
      <Col lg={1} md={1} xs={2} style={{ marginTop: '8px' }}>
        <label>Select Month</label>
      </Col>
      <Col lg={1} md={2} xs={4} style={{ marginTop: '8px' }}>
        <select
          className="form-control"
          id="Month"
          name="Month"
          onChange={onDDLChange}
        >
          {constants.Months.map((month) => (
            <option
              selected={defaultValue.Month === month.value}
              key={month.value}
              value={month.value}
            >
              {month.name}
            </option>
          ))}
        </select>
      </Col>
      <Col lg={1} md={1} xs={2} style={{ marginTop: '8px' }}>
        <label>Select Year</label>
      </Col>
      <Col lg={1} md={3} xs={4} style={{ marginTop: '8px' }}>
        <select
          className="form-control"
          id="Year"
          name="Year"
          onChange={onDDLChange}
        >
          {Years.map((x) => (
            <option
              key={x}
              selected={Number(defaultValue.Year) === x}
              value={x}
            >
              {x}
            </option>
          ))}
        </select>
      </Col>
    </Col>
  </Row>
);

const TabReliability = ({ hirarchy }) => {
  const [monthYear, setMonthYear] = useState({
    Month: moment(new Date()).format('MM'),
    Year: moment(new Date()).format('YYYY'),
  });

  const params = {
    type: hirarchy.type.label,
    id: hirarchy.level.value,
    yyyymm: monthYear.Year + monthYear.Month,
  };

  return (
    <>
      <MonthYear
        defaultValue={monthYear}
        onDDLChange={(e) =>
          setMonthYear({ ...monthYear, [e.target.name]: e.target.value })
        }
      />
      <Row>
        <Col lg={12} style={{ marginTop: '10px' }}>
          <CustomWidget size={4} id={'chrtPeakDemandProfile'}>
            <ChartReliabilityScores {...params} />
          </CustomWidget>
          <CustomWidget size={8} id={'chrtRelibilityIndiceProfile'}>
            <ReliabilityScoresYearly {...params} />
          </CustomWidget>
        </Col>
      </Row>
      <Row>
        <Col lg={12} style={{ marginTop: '10px' }}>
          <CustomWidget
            size={12}
            id={'chrtPeakDemandProfile'}
            title={'Monthly Interruption Profile'}
          >
            <ChartReliability {...params} />
          </CustomWidget>
        </Col>
      </Row>
    </>
  );
};

export default TabReliability;
